module.exports = __webpack_public_path__ + "static/media/4-4-do-nebe-vzal.efe141c6.jpg";